// Какие сутки попадут в ролик и что перед этим надо отрисовать.
//
// Растр в ролике едет по датам, а тайлы есть не на каждую: уборка держит семь
// суток. Здесь — чистое решение по ответам готовности; сами запросы и очередь
// рендера живут в ModelsPage.
//
// См. docs/plans/2026-08-16-video-drift-timeline-design.md

import { recordWindow, type RecordWindow } from '../map/videoTimeline'

/** Ответ готовности слоя на одну дату окна. */
export interface DayProbe {
  offset: number
  date: string
  /** Тайлы уже на диске — дата готова без работы. */
  tilesReady: boolean
  /** Поле в базе есть: тайлы можно нарисовать, это секунды на слой и глубину. */
  dataPresent: boolean
}

/** Окно ролика: непрерывный кусок вокруг текущей даты, где слой БУДЕТ в кадре.
 *
 *  Дата с данными, но без тайлов, окно не обрывает — её отрисуют перед записью.
 *  Дата без данных обрывает: рисовать нечего и неоткуда, а полный пайплайн
 *  (загрузка CMEMS плюс расчёт HSI — 44 минуты на дату) по клику «MP4» мы не
 *  запускаем. */
export function plannedWindow(probes: DayProbe[], current: number): RecordWindow | null {
  return recordWindow(
    probes.map(p => ({ offset: p.offset, ok: p.tilesReady || p.dataPresent })),
    current,
  )
}

/** Даты, которым нужен рендер, — и только те, что попадут в ролик.
 *
 *  Отрисовать дату за краем окна значило бы заплатить прогоном за кадр, которого
 *  в файле не будет. */
export function datesToRender(probes: DayProbe[], current: number): DayProbe[] {
  const win = plannedWindow(probes, current)
  if (!win) return []
  return probes
    .filter(p => p.offset >= win.from && p.offset <= win.to && !p.tilesReady && p.dataPresent)
    .sort((a, b) => a.offset - b.offset)
}
